import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/forecast.svg";
var ForecastOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ForecastOutline_default as default
};
